import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

const readUser = (key) => {
  try { return JSON.parse(localStorage.getItem(key) || "null"); } catch { return null; }
};

export function AuthProvider({ children }) {
  const [student, setStudent] = useState(() => readUser("lmc_student_user"));
  const [admin, setAdmin] = useState(() => readUser("lmc_admin_user"));
  const [loading, setLoading] = useState(false);

  const refreshStudent = useCallback(async () => {
    if (!localStorage.getItem("lmc_student_token")) { setStudent(null); return; }
    try {
      const { data } = await api.get("/auth/student/me");
      localStorage.setItem("lmc_student_user", JSON.stringify(data));
      setStudent(data);
    } catch {
      localStorage.removeItem("lmc_student_token");
      localStorage.removeItem("lmc_student_user");
      setStudent(null);
    }
  }, []);

  const refreshAdmin = useCallback(async () => {
    if (!localStorage.getItem("lmc_admin_token")) { setAdmin(null); return; }
    try {
      await api.get("/admin/dashboard");
    } catch {
      localStorage.removeItem("lmc_admin_token");
      localStorage.removeItem("lmc_admin_user");
      setAdmin(null);
    }
  }, []);

  useEffect(() => { refreshStudent(); refreshAdmin(); }, [refreshStudent, refreshAdmin]);

  const loginStudent = (token, user) => {
    localStorage.setItem("lmc_student_token", token);
    localStorage.setItem("lmc_student_user", JSON.stringify(user));
    setStudent(user);
  };
  const logoutStudent = () => {
    localStorage.removeItem("lmc_student_token");
    localStorage.removeItem("lmc_student_user");
    setStudent(null);
  };
  const loginAdmin = (token, user) => {
    localStorage.setItem("lmc_admin_token", token);
    localStorage.setItem("lmc_admin_user", JSON.stringify(user));
    setAdmin(user);
  };
  const logoutAdmin = () => {
    localStorage.removeItem("lmc_admin_token");
    localStorage.removeItem("lmc_admin_user");
    setAdmin(null);
  };

  return (
    <AuthContext.Provider value={{ student, admin, loading, loginStudent, logoutStudent, loginAdmin, logoutAdmin, refreshStudent }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
